<template>
  <div>
    <vxe-grid
      ref="budgetTable"
      border
      auto-resize
      highlight-hover-row
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="budGetTableData"
      :columns="tableColumns"
      resizable
      size="mini"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:subBudget="{ row }">
        {{ format(subBudget(row)) }}
      </template>
      <template v-slot:masterCategoryCode="{ row }">
        <el-cascader
          :options="categoryTree"
          :props="{
            emitPath: false,
            checkStrictly: false,
            value: 'value',
            label: 'label',
          }"
          v-model="row.masterCategoryCode"
          clearable
          filterable
          style="width: 100%"
          :showAllLevels="false"
        >
          <template slot-scope="{ node, data }">
            <span>{{ data.label }}</span>
            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
          </template>
        </el-cascader>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './budget-table-columns'
import { request } from '@/api/service'
import { format, add } from '@/libs/util.number.js'

export default {
  props: {
    tableData: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  watch: {
    tableData: {
      handler() {
        const tempData = this.tableData || []
        this.budGetTableData = [...tempData]
      },
      immediate: false,
      deep: true,
    },
  },
  computed: {
    subBudget() {
      return (row) => {
        if (row.estimatedQty) {
          return add(
              add(row.budgetQ2, row.budgetQ1),
              add(row.budgetQ3, row.budgetQ4)
            )
        }
        return 0
      }
    }
  },
  mounted() {
    this.loadSelectData()
    this.budGetTableData = [...this.tableData]
  },
  data() {
    return {
      budGetTableData: [{}],
      categoryTree: [],
      tableColumns: tableColumns(this),
      format: (number) => format(number),
      editRules: {
        channelSkuNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        channelItemNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        channelEanNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ row }) => {
              const { evgSkuCode, channelEanNo, _X_ID } = row
              const tableData = this.getTableData().filter(
                (item) => item._X_ID !== _X_ID
              )
              if (tableData && tableData.length) {
                const data = tableData.filter(
                  (item) =>
                    item.evgSkuCode === evgSkuCode &&
                    item.channelEanNo === channelEanNo
                )
                if (data && data.length) {
                  return new Error(
                    this.$l('tips_table_rules_repeat_channelEanNo')
                  )
                }
              }
            },
          },
        ],
        salesPrice: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        salesCurrencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  methods: {
    loadSelectData() {
      //产品类别
      request({
        url: '/ecom/ecom/amz/spu/category',
        method: 'post',
        data: { parentCode: 'ABSHome' },
      }).then((res) => {
        this.categoryTree = res.body.data
        this.categoryTree.push({
          label: 'Others',
          value: 'Others',
          children: null,
        })
      })
    },
    getTableData() {
      const { fullData } = this.$refs.budgetTable.getTableData()
      return (fullData || []).map((item) => {
        const { masterCategoryName: custName } = item
        return { ...item, custName, subBudget: this.subBudget(item) }
      })
    },
    async validate() {
      const result = await this.$refs.budgetTable.validate(true)
      return !result
    },
    push(row) {
      this.budGetTableData.push(row)
      this.$emit('updateTableData', this.budGetTableData)
    },
    del(row) {
      console.log(row)
      this.$refs.budgetTable.remove(row)
      this.budGetTableData = this.budGetTableData.filter(
        (item) => item._X_ID != row._X_ID
      )
      this.$emit('updateTableData', this.budGetTableData)
    },
  },
}
</script>
